export type OutgoingCognotaMessage = {
  type: 'open-request-modal';
  requestId: string;
};

export type IncomingCognotaMessage =
  | { type: 'request-modal-ready' }
  | { type: 'request-modal-closed' }
  | { type: 'open-request-fullpage'; requestId: string };

export function isIncomingCognotaMessage(
  data: unknown
): data is IncomingCognotaMessage {
  if (data === null || typeof data !== 'object') return false;
  const candidate = data as { type?: unknown; requestId?: unknown };

  if (candidate.type === 'request-modal-ready') return true;

  if (candidate.type === 'request-modal-closed') return true;

  if (
    candidate.type === 'open-request-fullpage' &&
    typeof candidate.requestId === 'string'
  ) {
    return true;
  }

  return false;
}
